module.exports = __webpack_public_path__ + "img/2.d5f77db3.png";